export default __webpack_public_path__ + "assets/home.7b77.svg";